export default "__VITE_ASSET__CDLG4evt__"